export default __webpack_public_path__ + "static/media/hallway-Up_W628-TIP-BEI90.e2a9fcfc.jpg";